import { render, staticRenderFns } from "./GroupsList.vue?vue&type=template&id=d7d7510e&scoped=true"
import script from "./GroupsList.vue?vue&type=script&lang=js"
export * from "./GroupsList.vue?vue&type=script&lang=js"
import style0 from "./GroupsList.vue?vue&type=style&index=0&id=d7d7510e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d7510e",
  null
  
)

export default component.exports